import React, { useEffect, useState, useMemo } from 'react';
import { Condition } from '../rule/rule-utils';
import MultiCondition, { MultiConditionTranslations } from '../multi-condition/multi-condition';
import SingleFreeTextRow, { FreeTextRowProps } from './single-free-text-row';
import { FreeText } from './types';

export interface FreeTextTranslations extends MultiConditionTranslations {
	equals: string;
	notEquals: string;
	include: string;
	exclude: string;
}

export interface FreeTextConditionProps {
	disabled?: boolean;
	index?: number;
	maxAttributePathItems?: number;
	condition: Condition;
	translations: FreeTextTranslations;
	parentContainerClass?: string;
	withIndexedLabel?: boolean;

	onChange(condition: Condition, value: FreeText[]): void;

	onRemove(condition: Condition): void;
}

const FreeTextCondition: React.FC<FreeTextConditionProps> = ({
	index,
	condition,
	onRemove,
	translations,
	parentContainerClass,
	onChange,
	maxAttributePathItems,
	withIndexedLabel = true,
	disabled = false
}: FreeTextConditionProps) => {
	const [options, setOptions] = useState<FreeTextRowProps['options']>([]);
	const multiConditionTranslations = useMemo(
		() => ({
			addRow: translations.addRow,
			removeTooltipText: translations.removeTooltipText
		}),
		[translations]
	);

	useEffect(() => {
		setOptions([
			{ id: 'EQUALS', name: translations.equals },
			{ id: 'NOT_EQUALS', name: translations.notEquals },
			{ id: 'INCLUDE', name: translations.include },
			{ id: 'EXCLUDE', name: translations.exclude }
		]);
	}, [translations]);

	return (
		<MultiCondition
			disabled={disabled}
			index={index}
			maxAttributePathItems={maxAttributePathItems}
			translations={multiConditionTranslations}
			condition={condition}
			onRemove={onRemove}
			onChange={onChange}
			withIndexedLabel={withIndexedLabel}
			rowClassName="free-text-row"
		>
			{({ singleCondition, setIsValid, onChange }) => (
				<SingleFreeTextRow
					disabled={disabled}
					onChange={onChange}
					setIsValid={setIsValid}
					singleCondition={singleCondition}
					parentContainerClass={parentContainerClass}
					options={options}
				/>
			)}
		</MultiCondition>
	);
};

export default FreeTextCondition;
